export default "__VITE_ASSET__JaHFIT5c__"